import { Button } from '@/components/ui/button';
import { SlidePanel } from '@/components/ui/slide-panel';

interface DeleteTeamDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  teamName: string;
}

export function DeleteTeamDialog({ open, onOpenChange, onConfirm, teamName }: DeleteTeamDialogProps) {
  return (
    <SlidePanel
      isOpen={open}
      onClose={() => onOpenChange(false)}
      title="Delete Team"
      width="sm"
      topOffset="4.5rem"
      showEdgeCloseButton={true}
    >
      <div className="space-y-4">
        <p className="text-sm text-muted-foreground">
          Are you sure you want to delete the team "{teamName}"? This action cannot be undone.
        </p>
        <div className="flex flex-col-reverse sm:flex-row gap-2 pt-4">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm}>
            Delete Team
          </Button>
        </div>
      </div>
    </SlidePanel>
  );
}
